import React from 'react';
import { StockIndicator } from '@hpstellar/core';

import useDeviceInfo from '../../../hooks/useDeviceInfo';

export default function StockIndicatorDiscontinued({ message }) {
    const { width } = useDeviceInfo();

    return (
        <StockIndicator
            className="discontinuedStockIndicator"
            color="grey"
            deliveryMessage={message}
            messagesOrientation={width < 768 ? 'vertical' : 'horizontal'}
            stockMessage="Discontinued"
        />
    );
}
